import { useState } from 'react';

export function useCadernoPartes(activeWorkspace) {
  const [editingPartes, setEditingPartes] = useState(false);
  const [partesAdversas, setPartesAdversas] = useState(() => {
    const raw = activeWorkspace?.partes?.adversas;
    return Array.isArray(raw) ? raw : [];
  });
  const [editingCoPartes, setEditingCoPartes] = useState(false);
  const [coPartesEdit, setCoPartesEdit] = useState(() => {
    const raw = Array.isArray(activeWorkspace?.partiesRefs) ? activeWorkspace.partiesRefs : [];
    return raw.filter((p) => p?.clientId || p?.name);
  });
  const [isCoPartePickerOpen, setIsCoPartePickerOpen] = useState(false);

  return {
    editingPartes, setEditingPartes,
    partesAdversas, setPartesAdversas,
    editingCoPartes, setEditingCoPartes,
    coPartesEdit, setCoPartesEdit,
    isCoPartePickerOpen, setIsCoPartePickerOpen,
  };
}
